<template>
    <b-skeleton class="changes" animation="wave"/>
</template>

<script>
export default {
  name: "ChangeSkeletonBox"
};
</script>
